import React from 'react';
import { Layout, MenuItemLink, usePermissions } from 'react-admin';
import CustomAppBar from './CustomAppBar';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FactoryIcon from '@mui/icons-material/Factory';
import PlaceIcon from '@mui/icons-material/Place';
import InboxIcon from '@mui/icons-material/Inbox';
import PeopleIcon from '@mui/icons-material/People';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LandscapeIcon from '@mui/icons-material/Landscape';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import StorefrontIcon from '@mui/icons-material/Storefront';

const menuItems = [
    { name: 'orders', text: 'Orders', icon: <InboxIcon /> },
    { name: 'customers', text: 'Customers', icon: <PeopleIcon /> },
    { name: 'products', text: 'Products', icon: <LandscapeIcon /> },
    { name: 'pickuplocations', text: 'Pickup Locations', icon: <FactoryIcon /> },
    { name: 'deliverylocations', text: 'Delivery Locations', icon: <PlaceIcon /> },
    { name: 'truckingcompanies', text: 'Trucking Companies', icon: <LocalShippingIcon /> },
    { name: 'orderdetails', text: 'Order Reconciliation', icon: <AssessmentIcon /> },
    { name: 'users', text: 'Users', icon: <ManageAccountsIcon />, adminOnly: true },
    { name: 'customeraccounts', text: 'Customer Accounts', icon: <StorefrontIcon />, adminOnly: true },
];

const MyMenu = ({ onMenuClick, logout }) => {
  const { permissions } = usePermissions();

  // Filter menu items based on permissions
  const visibleItems = menuItems.filter(item => {
    if (item.adminOnly && !permissions?.isAdmin) {
      return false;
    }
    return true;
  });

  return (
    <div style={{paddingTop: '20px'}}>
      { visibleItems.map(item => (
        <MenuItemLink
          key={item.name}
          to={`/${item.name}`}
          primaryText={item.text}
          leftIcon={item.icon}
          onClick={onMenuClick}
        />
      ))}
      <MenuItemLink
          key="reports"
          to="/reports/create"
          primaryText="Billing Report"
          leftIcon={<ReceiptIcon />}
          onClick={onMenuClick}
      />
      <MenuItemLink
          key="ordersexport"
          to="/ordersexport"
          primaryText="Orders Export"
          leftIcon={<CloudDownloadIcon />}
          onClick={onMenuClick}
      />
    </div>
  );
};

const MyLayout = props => <Layout {...props} menu={MyMenu} appBar={CustomAppBar} />;

export default MyLayout;
